module.exports = __webpack_public_path__ + "img/image14.46d95971.png";